'use client';

import React from 'react';

import styles from './dialog.module.scss';

export type DialogHeaderProps = {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  id?: string;
  className?: string;
  style?: React.CSSProperties;
};

export function DialogHeader({
  title,
  subtitle,
  actions,
  id,
  className,
  style
}: DialogHeaderProps) {
  return (
    <header
      className={`${styles.header} ${className || ''}`}
      id={id}
      style={style}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.25rem',
          minWidth: 0
        }}
      >
        {title && (
          <div
            style={{
              fontSize: 'var(--font-size-h3, 1.5rem)',
              fontWeight: 700,
              lineHeight: 1.2
            }}
          >
            {title}
          </div>
        )}
        {subtitle && (
          <div
            style={{ color: 'var(--ds-muted, #4b5563)', fontSize: '0.875rem' }}
          >
            {subtitle}
          </div>
        )}
      </div>
      {actions}
    </header>
  );
}
